// @flow
import React from "react";
import { MenuItemContainer } from "./styles";

type Props = {
  children: React$Node,
};

export const MenuItem = ({ children, ...props }: Props) => {
  return <MenuItemContainer {...props}>{children}</MenuItemContainer>;
};
